import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { HttpHeaders } from '@angular/common/http';
import { LoaderService } from 'src/app/service/loader.service';
import { RestService } from 'src/app/service/rest.service';
import { MatDialogComponent } from '../../dialog-box/mat-dialog/mat-dialog.component';
import { CommonService } from 'src/app/service/common.service';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { MenuIdService } from 'src/app/service/menu-id.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  loginForm!: FormGroup;
  submitted = false;
  orgAppId: any;
  imageURL!: Observable<string>;
  url:any;
  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private loader: LoaderService,
    private router: Router,
    private restService: RestService,
    private translate: TranslateService,
    private commonService: CommonService,
    private route: ActivatedRoute,
    private cookieService: CookieService,
    public menuIdService: MenuIdService
  ) {
  }

  ngOnInit(): void {

    this.imageURL = this.menuIdService.getActiveImageURL();
    this.loginForm = this.fb.group({
      username: ['', [Validators.required, Validators.pattern(/^\s*[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\s*$/)]]
    });
    this.orgAppId = this.cookieService.get('orgAppId');
    let userSettings = window.localStorage.getItem('userSettings');
    if (userSettings) {
      let userSettingParsed = JSON.parse(userSettings);
      let lang = userSettingParsed.lang;
      if (lang) {
        this.translate.setDefaultLang(lang);
        this.translate.use(lang);
      } else {
        this.translate.setDefaultLang('en');
        this.translate.use('en');
      }
    }
  }

  get control() {
    return this.loginForm.controls;
  }

  login() {
    this.submitted = true;
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    }

    const headers = new HttpHeaders({
      'orgAppID': this.orgAppId.toString()
    });

    let params = {
      emailID: this.control['username'].value.trim()
    }

    this.loader.show();
    this.restService.postUATData(params, 'api/digital/core/Account/ForgotPassword', headers).subscribe({
      next: (data: any) => {
        this.loader.hide();
        if (data.rcode == 200) {
          let _dialogRef = this.dialog.open(MatDialogComponent, {
            width: '50VW',
            disableClose: true,
            data: {
              success: true,
              trnID: data.rObj.transactionRef,
              errorMessage: this.translate.instant('forgot_password_link_sent')
            }
          })
          _dialogRef.afterClosed().subscribe(result => {
            if (result) {
              this.url = this.cookieService.get('redirect_url');
              if (this.url) {
                const redirectUrl = new URL(this.url);
                const baseUrl = `${redirectUrl.protocol}//${redirectUrl.hostname}${redirectUrl.port ? ':' + redirectUrl.port : ''}`;
                window.location.href = baseUrl; 
              }
            }
          })
        }
      },
      error: (error: any) => {
        this.loader.hide();
        if (
          error.error.rcode !== 401 &&
          error.error.rcode !== 403 &&
          error.error.rcode !== 404 &&
          error.error.rcode !== 500
        ) {

          let errorCode = error.error.rmsg[0].errorCode ?? 'ERROR'
          this.commonService.handleStatusError(error);
        }

        //this.commonService.apiErrorMessageDialog(error.error.trnID, errorCode);
      }
    })
  }
}
